import { css } from '@/styled-system/css';

// Direction colours follow PricingComparisonModule: cheaper reads as brand teal, more expensive as red.
// The trend icon and the signed value carry direction without colour (WCAG 1.4.1).
export const decrease = css({ color: 'text.accent.brand.hero' });
// red.400 matches PricingComparisonModule in light mode (no semantic text red resolves to it); red.300 keeps 4.5:1 on dark.
export const increase = css({ color: { base: 'red.400', _dark: 'red.300' } });

export const content = css({ display: 'flex', flexDirection: 'column', gap: 'tight' });

export const table = css({
  width: '100%',
  '& th, & td': { backgroundColor: 'bg.neutral', verticalAlign: 'top', paddingBlock: 'tight' },
  '& th:first-child, & td:first-child': { paddingInlineStart: '0' },
  '& th:last-child, & td:last-child': { paddingInlineEnd: '0' },
  '& th': {
    fontSize: 'body-sm',
    lineHeight: 'body-sm',
    fontWeight: 'normal',
    color: 'text.subtle',
    paddingBlock: 'tighter',
  },
});

export const cellStack = css({ display: 'flex', flexDirection: 'column', gap: 'micro.default', minWidth: '0' });
export const priceStack = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: 'micro.default',
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
});
export const meta = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  columnGap: 'tightest',
  rowGap: 'micro.default',
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  overflowWrap: 'anywhere',
});
export const rowDelta = css({ display: 'flex', alignItems: 'center', gap: 'micro.default' });
export const logo = css({ maxHeight: '400', maxWidth: '2400', width: 'auto', objectFit: 'contain' });

export const source = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  flexWrap: 'wrap',
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});
export const disclaimerLogo = css({ maxWidth: '100%', objectFit: 'contain' });
export const disclaimer = css({
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  '& p': { marginBlock: 'tighter' },
  '& a': { color: 'text.action.hero.default', textDecoration: 'underline', overflowWrap: 'anywhere' },
  '& ul, & ol': { paddingInlineStart: 'loose' },
  '& img': { maxWidth: '100%' },
});
